module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0119.jpg?v=ff28d7af";